import { createAction, props } from '@ngrx/store';
import { IOdbBillAggregatorResponse } from 'src/app/my-bill/models/aggregator.model';

export const GET_BILLING_AGGREGATOR_REQUEST = 'GET_BILLING_AGGREGATOR_REQUEST';
export const GET_BILLING_AGGREGATOR_SUCCESS = 'GET_BILLING_AGGREGATOR_SUCCESS';
export const GET_BILLING_AGGREGATOR_FAILURE = 'GET_BILLING_AGGREGATOR_FAILURE';

export const getBillingAggregatorRequest = createAction(
  GET_BILLING_AGGREGATOR_REQUEST
);

export const getBillingAggregatorSuccess = createAction(
  GET_BILLING_AGGREGATOR_SUCCESS,
  props<{
    billAggregatorResponse: IOdbBillAggregatorResponse;
  }>()
);

export const getBillingAggregatorFailure = createAction(
  GET_BILLING_AGGREGATOR_FAILURE
);
